"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForthSectionWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ForthSectionWrap = styled_components_1.default.section `
  gap: 20px;
  max-width: 312px;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
  position: relative;

  p {
    margin: 0;
    padding: 0;
  }

  .landing-forth-section-step {
    display: flex;
    gap: 12px;
    align-items: center;
    width: 100%;
    justify-content: flex-start;
    z-index: 1;

    &.landing-forth-section-right {
      flex-direction: row-reverse;
    }

    .landing-forth-section-step-description {
      display: flex;
      flex-direction: column;
      background-color: white;
      border-radius: 18px;
      gap: 12px;
      padding: 12px;

      .landing-forth-section-step-description-content {
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: center;
        justify-content: center;

        p {
          font-family: Inter, sans-serif;
          font-size: 16px;
          font-weight: 500;
          line-height: 19px;
          color: #333333;
        }

        svg {
          width: 58px;
          height: 58px;
        }
      }

      .landing-forth-section-step-buttons {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;

        button {
          cursor: pointer;
          background-color: #6e76fb;
          color: white;
          border-radius: 12px;
          border: none;
          padding: 10px 12px;
          font-family: Inter, sans-serif;
          font-size: 16px;
          font-weight: 600;
          line-height: 19px;
          width: fit-content;
          margin: 0 auto;
        }
      }
    }

    .landing-forth-section-step-number {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px;
      background-color: white;
      border-radius: 18px;
      font-family: Phenomena, sans-serif;
      font-size: 24px;
      font-weight: 700;
      line-height: 29px;
      color: #6e76fb;
      text-wrap: nowrap;
    }
  }

  .landing-forth-section-line {
    position: absolute;
    z-index: 0;
    top: 148px;
    left: 38px;

    .landing-line-360_svg__landing-line-360 {
      @media screen and (min-width: 768px) {
        display: none;
      }
    }
    .landing-line-768_svg__landing-line-768 {
      @media screen and (max-width: 767px), (min-width: 1000px) {
        display: none;
      }
    }
    .landing-line-1000_svg__landing-line-1000 {
      @media screen and (max-width: 999px), (min-width: 1300px) {
        display: none;
      }
    }
    .landing-line-1300_svg__landing-line-1300 {
      @media screen and (max-width: 1299px), (min-width: 1690px) {
        display: none;
      }
    }
    .landing-line-1690_svg__landing-line-1690 {
      @media screen and (max-width: 1689px), (min-width: 1920px) {
        display: none;
      }
    }
    .landing-line-1920_svg__landing-line-1920 {
      @media screen and (max-width: 1919px) {
        display: none;
      }
    }
  }

  .landing-forth-section-step-description {
    justify-content: center;
  }

  .landing-forth-section-step-1 {
    .landing-forth-section-step-description {
      min-width: 216px;
      min-height: 249px;
    }
  }
  .landing-forth-section-step-2 {
    .landing-forth-section-step-description {
      min-width: 216px;
      min-height: 221px;
    }
  }
  .landing-forth-section-step-3 {
    .landing-forth-section-step-description {
      min-width: 205px;
      min-height: 221px;
    }
  }
  .landing-forth-section-step-4 {
    .landing-forth-section-step-description {
      min-width: 227px;
      min-height: 246px;
    }
  }
  .landing-forth-section-step-5 {
    .landing-forth-section-step-description {
      min-width: 212px;
      min-height: 189px;
    }
  }
  .landing-forth-section-step-6 {
    .landing-forth-section-step-description {
      min-width: 226px;
      min-height: 259px;
    }
  }

  @media screen and (min-width: 768px) {
    gap: 20px;
    max-width: 728px;

    .landing-forth-section-step {
      gap: 12px;

      .landing-forth-section-step-description {
        border-radius: 18px;
        gap: 12px;
        padding: 20px 23px;

        .landing-forth-section-step-description-content {
          flex-direction: row;
          gap: 12px;

          p {
            font-size: 24px;
            font-weight: 500;
            line-height: 29px;
          }
        }

        .landing-forth-section-step-buttons {
          button {
            border-radius: 26px;
            padding: 10px 24px;
          }
        }
      }

      .landing-forth-section-step-number {
        padding: 20px 23px;
        border-radius: 18px;
        font-size: 42px;
        line-height: 50px;
      }
    }

    .landing-forth-section-step-2 {
      P {
        max-width: 287px;
      }
    }
    .landing-forth-section-step-3 {
      P {
        max-width: 271px;
      }
    }
    .landing-forth-section-step-4 {
      P {
        max-width: 367px;
      }
    }
    .landing-forth-section-step-5 {
      P {
        max-width: 302px;
      }
    }
    .landing-forth-section-step-6 {
      P {
        max-width: 302px;
      }
    }
    .landing-forth-section-line {
      top: 137px;
      left: 158px;
    }
    .landing-forth-section-step-1 {
      .landing-forth-section-step-description {
        min-width: 365px;
        min-height: 169px;
      }
    }
    .landing-forth-section-step-2 {
      .landing-forth-section-step-description {
        min-width: 403px;
        min-height: 208px;
      }
    }
    .landing-forth-section-step-3 {
      .landing-forth-section-step-description {
        min-width: 387px;
        min-height: 179px;
      }
    }
    .landing-forth-section-step-4 {
      .landing-forth-section-step-description {
        min-width: 483px;
        min-height: 214px;
      }
    }
    .landing-forth-section-step-5 {
      .landing-forth-section-step-description {
        min-width: 459px;
        min-height: 156px;
      }
    }
    .landing-forth-section-step-6 {
      .landing-forth-section-step-description {
        min-width: 418px;
        min-height: 237px;
      }
    }
  }

  @media screen and (min-width: 1000px) {
    gap: 24px;
    max-width: 920px;

    .landing-forth-section-step {
      gap: 12px;

      .landing-forth-section-step-description {
        border-radius: 18px;
        gap: 12px;
        padding: 20px 23px;

        .landing-forth-section-step-description-content {
          flex-direction: row;
          gap: 12px;

          p {
            font-size: 24px;
            font-weight: 500;
            line-height: 29px;
          }
        }

        .landing-forth-section-step-buttons {
          button {
            border-radius: 26px;
            padding: 10px 24px;
          }
        }
      }

      .landing-forth-section-step-number {
        padding: 20px 23px;
        border-radius: 18px;
        font-size: 42px;
        line-height: 50px;
      }
    }

    .landing-forth-section-step-1 {
      .landing-forth-section-step-description {
        min-width: 365px;
        min-height: 196px;
      }
    }

    .landing-forth-section-step-2 {
      .landing-forth-section-step-description {
        min-width: 403px;
        min-height: 208px;
      }
    }
    .landing-forth-section-step-3 {
      .landing-forth-section-step-description {
        min-width: 387px;
        min-height: 179px;
      }
    }
    .landing-forth-section-step-4 {
      .landing-forth-section-step-description {
        min-width: 463px;
        min-height: 214px;
      }
    }
    .landing-forth-section-step-5 {
      .landing-forth-section-step-description {
        min-width: 392px;
        min-height: 185px;
      }
    }
    .landing-forth-section-step-6 {
      .landing-forth-section-step-description {
        min-width: 418px;
        min-height: 237px;
      }
    }

    .landing-forth-section-step-2 {
      P {
        max-width: 287px;
      }
    }
    .landing-forth-section-step-3 {
      P {
        max-width: 271px;
      }
    }
    .landing-forth-section-step-4 {
      P {
        max-width: 347px;
      }
    }
    .landing-forth-section-step-5 {
      P {
        max-width: 267px;
      }
    }
    .landing-forth-section-step-6 {
      P {
        max-width: 302px;
      }
    }

    .landing-forth-section-line {
      top: 129px;
      left: 379px;
    }
  }

  @media screen and (min-width: 1300px) {
    gap: 24px;
    max-width: 1220px;
    margin-top: 100px;
    margin-bottom: 100px;

    .landing-forth-section-step {
      gap: 24px;

      .landing-forth-section-step-description {
        border-radius: 35px;
        gap: 24px;
        padding: 40px 45px;

        .landing-forth-section-step-description-content {
          gap: 24px;

          svg {
            width: 110px;
            height: 110px;
          }

          p {
            font-size: 36px;
            line-height: 44px;
          }
        }

        .landing-forth-section-step-buttons {
          button {
            border-radius: 50px;
            padding: 20px 51px;
            font-size: 24px;
            font-weight: 600;
            line-height: 29px;
          }
        }
      }

      .landing-forth-section-step-number {
        padding: 40px 45px;
        border-radius: 35px;
        font-size: 64px;
        line-height: 77px;
      }
    }

    .landing-forth-section-step-1 {
      .landing-forth-section-step-description {
        min-width: 597px;
        min-height: 364px;
      }
    }

    .landing-forth-section-step-2 {
      .landing-forth-section-step-description {
        min-width: 661px;
        min-height: 349px;
      }
    }
    .landing-forth-section-step-3 {
      .landing-forth-section-step-description {
        min-width: 632px;
        min-height: 305px;
      }
    }
    .landing-forth-section-step-4 {
      .landing-forth-section-step-description {
        min-width: 846px;
        min-height: 300px;
      }
    }
    .landing-forth-section-step-5 {
      .landing-forth-section-step-description {
        min-width: 639px;
        min-height: 300px;
      }
    }
    .landing-forth-section-step-6 {
      .landing-forth-section-step-description {
        min-width: 663px;
        min-height: 393px;
      }
    }

    .landing-forth-section-step-2 {
      P {
        max-width: 437px;
      }
    }
    .landing-forth-section-step-3 {
      P {
        max-width: 408px;
      }
    }
    .landing-forth-section-step-4 {
      P {
        max-width: 622px;
      }
    }
    .landing-forth-section-step-5 {
      P {
        max-width: 415px;
      }
    }
    .landing-forth-section-step-6 {
      P {
        max-width: 454px;
      }
    }

    .landing-forth-section-line {
      top: 225px;
      left: 228px;
    }
  }

  @media screen and (min-width: 1690px) {
    gap: 24px;
    max-width: 1354px;

    .landing-forth-section-step {
      gap: 24px;

      .landing-forth-section-step-description {
        border-radius: 35px;
        gap: 24px;
        padding: 40px 45px;

        .landing-forth-section-step-description-content {
          gap: 24px;

          svg {
            width: 110px;
            height: 110px;
          }

          p {
            font-size: 36px;
            line-height: 44px;
          }
        }

        .landing-forth-section-step-buttons {
          button {
            border-radius: 50px;
            padding: 20px 51px;
            font-size: 24px;
            font-weight: 600;
            line-height: 29px;
          }
        }
      }

      .landing-forth-section-step-number {
        padding: 40px 45px;
        border-radius: 35px;
        font-size: 64px;
        line-height: 77px;
      }
    }

    .landing-forth-section-step-1 {
      .landing-forth-section-step-description {
        min-width: 597px;
        min-height: 364px;
      }
    }

    .landing-forth-section-step-2 {
      .landing-forth-section-step-description {
        min-width: 661px;
        min-height: 349px;
      }
    }
    .landing-forth-section-step-3 {
      .landing-forth-section-step-description {
        min-width: 632px;
        min-height: 305px;
      }
    }
    .landing-forth-section-step-4 {
      .landing-forth-section-step-description {
        min-width: 846px;
        min-height: 300px;
      }
    }
    .landing-forth-section-step-5 {
      .landing-forth-section-step-description {
        min-width: 639px;
        min-height: 300px;
      }
    }
    .landing-forth-section-step-6 {
      .landing-forth-section-step-description {
        min-width: 663px;
        min-height: 393px;
      }
    }

    .landing-forth-section-step-2 {
      P {
        max-width: 437px;
      }
    }
    .landing-forth-section-step-3 {
      P {
        max-width: 408px;
      }
    }
    .landing-forth-section-step-4 {
      P {
        max-width: 622px;
      }
    }
    .landing-forth-section-step-5 {
      P {
        max-width: 415px;
      }
    }
    .landing-forth-section-step-6 {
      P {
        max-width: 454px;
      }
    }

    .landing-forth-section-line {
      top: 225px;
      left: 342px;
    }
  }

  @media screen and (min-width: 1920px) {
    max-width: 1584px;

    .landing-forth-section-line {
      top: 225px;
      left: 593px;
    }
  }
`;
